import * as orderhistory from '../actions/order-history.actions';

import { Product } from '../../core/models/product';

export interface State {
  loading: boolean;
  error: any;
  products: Product[];
}

export const initialState: State = {
  loading: false,
  error: null,
  products: [],
}

export function reducer(state = initialState, action: orderhistory.OrderHistoryActions): State {
  switch (action.type) {
    case orderhistory.OrderHistoryActionTypes.LoadReOrderableItems:
      return {
        ...state,
        loading: true,
      }

    case orderhistory.OrderHistoryActionTypes.LoadReOrderableItemsSuccess:
      return {
        ...state,
        loading: false,
        products: action.payload.results,
      }

    case orderhistory.OrderHistoryActionTypes.LoadReOrderableItemsFailed:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    case orderhistory.OrderHistoryActionTypes.ResetOrderHistoryLines:
      return Object.assign({}, initialState)

    default:
      return state
  }
}


export const getLoading = (state: State) => state.loading
export const getError = (state: State) => state.error
export const getReOrderableItemCodes = (state: State) =>  {
  if (state && state.products && state.products.length > 0) {
    return state.products.map(product => product.code)
  }

  return []
}
